<div class="modal-overlay" [class.open]="isOpen" (click)="onClose()">
    <div class="modal-container" [class.add-goal-mode]="isAddGoalOpen" (click)="$event.stopPropagation()">
        <!-- Savings Plans List View -->
        <ng-container *ngIf="!isAddGoalOpen">
            <div class="modal-header">
                <h2 class="modal-title">Savings Plans</h2>
                <button class="done-btn" (click)="onClose()">Done</button>
            </div>

            <div class="modal-body">
                <div *ngIf="isLoading" class="loading-container">
                    <div class="loader"></div>
                    <p>Loading plans...</p>
                </div>

                <div class="plans-list" *ngIf="!isLoading">
                    <div class="plan-item" *ngFor="let item of savingPlans">
                        <div class="plan-item__left">
                            <div class="plan-item__header">
                                <div class="plan-icon-wrapper">
                                    <img [src]="item.icon" alt="goal-icon">
                                </div>
                                <div class="plan-item__info">
                                    <div class="plan-item__label">Goal:</div>
                                    <div class="plan-item__name">{{ item.goalName }}</div>
                                </div>
                            </div>
                            <div class="plan-item__saved">Spent {{ item.savedAmount }}</div>
                            <div class="plan-item__progress-section">
                                <div class="progress-bar-container">
                                    <div class="progress-bar"
                                        [style.width.%]="item.percentage > 100 ? 100 : item.percentage"
                                        [class.exceeded]="item.percentage > 100">
                                    </div>
                                </div>
                                <span class="percentage-text" [class.exceeded]="item.percentage > 100">{{
                                    item.percentage
                                    }}%</span>
                            </div>
                        </div>

                        <div class="plan-item__right">
                            <div class="plan-item__target">{{ item.targetAmount }}</div>
                            <div class="plan-item__actions">
                                <button class="action-btn pin-btn" [class.pinned]="item.isPinned"
                                    (click)="togglePin(item)">
                                    {{ item.isPinned ? 'Pinned' : 'Pin' }}
                                </button>
                                <button class="action-btn edit-btn" (click)="onEdit(item)">Edit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button class="add-goal-btn" (click)="onAddNewGoal()">
                    Create New Goal
                    <img src="assets/icons/arrow-right.svg" alt="arrow-right">
                </button>
            </div>
        </ng-container>

        <!-- Add New Goal View -->
        <ng-container *ngIf="isAddGoalOpen">
            <div class="modal-header add-goal-header">
                <button class="cancel-btn" (click)="isAddGoalOpen = false">Cancel</button>
                <h2 class="modal-title">Create New Goal</h2>
                <button class="save-btn" (click)="onSaveGoal()">Save</button>
            </div>

            <div class="modal-body add-goal-body">
                <div class="form-group">
                    <label class="form-label">Name Goal</label>
                    <div class="input-wrapper name-input-wrapper" [class.has-error]="errors['name']">
                        <input type="text" class="form-input" placeholder="Enter goal name" [(ngModel)]="newGoalName">
                        <img src="assets/icons/target-05.svg" alt="target" class="input-icon">
                    </div>
                    <span class="error-text" *ngIf="errors['name']">{{ errors['name'] }}</span>
                </div>

                <div class="goal-details-container">
                    <div class="form-group">
                        <label class="form-label">Budget Goal</label>
                        <div class="input-wrapper budget-input-wrapper" [class.has-error]="errors['budget']">
                            <input type="text" class="form-input amount-input" placeholder="0.00"
                                [(ngModel)]="newGoalBudget">
                            <span class="currency-code">INR</span>
                        </div>
                        <span class="error-text" *ngIf="errors['budget']">{{ errors['budget'] }}</span>
                    </div>

                    <div class="form-group">
                        <label class="form-label">Account</label>
                        <div class="account-selector">
                            <div class="account-info">
                                <div class="account-name">Credit Card 1</div>
                                <div class="account-number">**** 1234</div>
                            </div>
                            <button class="change-account-btn">
                                Change
                                <img src="assets/icons/direction-down.svg" alt="chevron">
                            </button>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label class="form-label">Payment Debit Date</label>
                    <div class="input-wrapper date-input-wrapper" (click)="toggleCalendar()">
                        <input type="text" class="form-input" [value]="paymentDebitDate" readonly
                            placeholder="05 July 2025">
                        <img src="assets/icons/calendar.svg" alt="calendar" class="input-icon">
                    </div>
                </div>

                <div class="add-payment-date-section">
                    <button class="add-payment-date-btn">
                        <img src="assets/icons/img_pencil.svg" alt="edit">
                        Add New Payment Date
                    </button>
                </div>
            </div>

            <app-calendar *ngIf="isCalendarOpen" [selectedDate]="getSelectedDate()" (dateSelect)="onDateSelect($event)"
                (close)="isCalendarOpen = false">
            </app-calendar>
        </ng-container>
    </div>
</div>